import { useReadySession } from '../../session/useSession'
import { ChangePasswordForm } from './ChangePasswordForm'
import { PASSWORD_COPY } from './copy'

export const PasswordSettings = () => {
  const { changePassword } = useReadySession()
  return (
    <section className="card settings-card" aria-labelledby="password-heading">
      <h2 id="password-heading">{PASSWORD_COPY.settingsTitle}</h2>
      <p className="settings-hint measure">{PASSWORD_COPY.settingsHint}</p>
      <ChangePasswordForm id="settings-password" currentLabel={PASSWORD_COPY.current} onChange={changePassword} />
    </section>
  )
}
